import { useSelector } from '/druid/internal/WebChatReduxContext';
import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useSendBoxValue(): [string, (value: string) => void] {
  return [useSelector(({ sendBoxValue }) => sendBoxValue), useWebChatAPIContext().setSendBox];
}
